import { COLOR_BACKGROUND_ACCENT, COLOR_TEXT_DARK } from '@alltrails/denali/tokens';

type MapCenterMarkerProps = { className?: string };

// Keep consistent with distanceAwayCenterSvg in maps package
const MapCenterMarker = ({ className }: MapCenterMarkerProps) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true" focusable="false">
      <defs>
        <radialGradient id="circle-shadow">
          <stop stop-color="#000000" stop-opacity="0.3" />
          <stop offset="70%" stop-color="#000000" stop-opacity="0.3" />
          <stop offset="100%" stop-color="#000000" stop-opacity="0" />
        </radialGradient>
      </defs>
      <circle cx={12} cy={12} r={12} fill="url(#circle-shadow)" />
      <circle cx={12} cy={12} r={10} fill={COLOR_TEXT_DARK} />
      <circle cx={12} cy={12} r={7} fill={COLOR_BACKGROUND_ACCENT} />
      <circle cx={12} cy={12} r={3} fill={COLOR_TEXT_DARK} />
    </svg>
  );
};

export default MapCenterMarker;
